import {
    TimeHeaderCell,
    TimeHeaderCellProps,
} from '@progress/kendo-react-scheduler'
import { classNames } from 'utils/dom-helpers'

export function TimeCell(p: TimeHeaderCellProps) {
    return (
        <TimeHeaderCell
            {...p}
            format="ha"
            className={classNames(p.className || '', 'w-16')}
        />
    )
}

export default TimeCell
